/** The Gallery's remembered UI state, the same keys on web and the app. */
export const GALLERY_STORAGE_KEYS = {
    /** The last sort picked. V2 drops sorts saved before Newest became the default. */
    sort: "gallerySortV2",
    plannerOpen: "galleryPlannerOpen",
    /** Set once the planner is opened; until then it says "Fine-tune" once solutions are built. */
    plannerSeen: "easysbc.galleryPlannerSeen",
    solveGuideOpen: "gallerySolveGuideOpen",
    firstOwnerGuideOpen: "galleryFirstOwnerGuideOpen",
    /** The planner's last inputs (a GalleryPlanInput), so a reload rebuilds the same plan. */
    plannerInput: "galleryPlannerInput",
    /** The planner's last plan (a SavedGalleryPlan), so leaving the page and coming back shows the same plan. */
    plan: "galleryPlan",
    levelsGuideOpen: "galleryLevelsGuideOpen",
    /** The Levels page's Customize options (a GalleryLevelSettings). */
    levelSettings: "galleryLevelSettings",
    /** Buy cards of the level plan ticked as bought since the last build; the plan's cards don't belong to one set. */
    levelBoughtTicks: "galleryLevelBoughtTicks",
    /** The Collected Players Sync this browser started, so every Gallery page keeps showing its progress. */
    collectedSyncRun: "galleryCollectedSyncRun",
};
//# sourceMappingURL=keys.js.map